<template>
  <section class="results" id="resultsDiv" v-if="programlar.length > 0">
    <h2 class="results__title">Başvuru Yapabileceğiniz Programlar</h2>
    <p class="results__subtitle">
      {{ programlar.length }} program bulundu — koşulları görmek için “Detay”a
      tıklayın.
    </p>

    <p v-if="!isNewApplicationOpen" class="alert-pastdata">
      <strong>Önemli not:</strong> Lisansüstü öğrenci alım tarihi henüz
      belirlenmemiştir. Aşağıdaki program bilgileri geçmiş dönemlere ait
      verilerdir; yeni alımlar açıklandığında
      <strong>ilgili şartlar değişiklik gösterebilir</strong>. Alımlardan
      haberdar olmak için
      <a data-toggle="modal" data-target="#newsletter">bültene kayıt olun</a>.
    </p>

    <div class="results-card">
      <table class="results-table">
        <thead>
          <tr>
            <th class="text-left">Program</th>
            <th class="text-left">Uzmanlık Alanı</th>
            <th class="text-left">Başvuru Dönemi</th>
            <th class="text-left">Min. Lisans Notu</th>
            <th class="text-left" v-if="selectedProgramTypeId === 5371">
              Min. Y. Lisans Notu
            </th>
            <th><span class="sr-only">Detay</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="program in programlar" :key="program.id">
            <td class="cell-program" data-label="Program">
              {{ program["acilanProgramBilgileri"]["birim"]["birimAdi"] }}
            </td>
            <td data-label="Uzmanlık Alanı">
              {{
                program["acilanProgramBilgileri"]["birimGrubu"]["adi"] || "—"
              }}
            </td>
            <td class="cell-dates" data-label="Başvuru Dönemi">
              <span v-if="isNewApplicationOpen"
                >{{
                  $filters.formatDate(
                    program["acilanProgramBilgileri"]["baslamaTarihi"]
                  )
                }}
                –
                {{
                  $filters.formatDate(
                    program["acilanProgramBilgileri"]["bitisTarihi"]
                  )
                }}</span
              >
              <span v-else>—</span>
            </td>
            <td data-label="Min. Lisans Notu">
              <span class="grade"
                >{{
                  program["acilanProgramBilgileri"][
                    "minimumMezuniyetNotu100sistem"
                  ]
                }}<small>/100</small></span
              >
              <span class="grade"
                >{{
                  program["acilanProgramBilgileri"][
                    "minimumMezuniyetNotu4sistem"
                  ]
                }}<small>/4</small></span
              >
            </td>
            <td
              v-if="selectedProgramTypeId === 5371"
              data-label="Min. Y. Lisans Notu"
            >
              <span class="grade"
                >{{ program["acilanProgramBilgileri"]["minYLMezNotu100"]
                }}<small>/100</small></span
              >
              <span class="grade"
                >{{ program["acilanProgramBilgileri"]["minYLMezNotu4"]
                }}<small>/4</small></span
              >
            </td>
            <td class="cell-action">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                data-toggle="modal"
                data-target="#detay"
                @click="showDetails(program['acilanProgramBilgileri'])"
              >
                Detay
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
  <ProgramDetail
    :programInfo="selectedProgram"
    :isNewApplicationOpen="isNewApplicationOpen"
    :selectedProgramTypeId="selectedProgramTypeId"
    :announcementUrl="announcementUrl"
  />
</template>

<script>
import ProgramDetail from "@/components/ProgramDetail.vue";

export default {
  name: "ResultsProgram",
  data() {
    return {
      selectedProgram: null,
    };
  },
  props: {
    programlar: {
      type: Object,
    },
    isNewApplicationOpen: {
      type: Boolean,
    },
    selectedProgramTypeId: {
      type: Number,
    },
    announcementUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    showDetails(program) {
      this.selectedProgram = program;
    },
  },
  components: { ProgramDetail },
};
</script>

<style scoped></style>
